import React, { useState } from 'react';
import { Button, DatePicker, Form, Modal, Input, Space } from 'antd';
import client from '@/lib/feathers';
import dayjs from 'dayjs';
import PreviewAnnouncement from '../PreviewAnnouncement';
import UploadFileForAnnouncement from '../UploadFileForAnnouncement';
import styles from './index.module.scss';
import type { UploadedFileInfo } from '../types';

interface PublishAnnouncementProps {
  disabled: boolean;
  propsForAnnouncement: {
    closingOrderNumber: number;
    closingOrderUnit: string;
  };
}

const { TextArea } = Input;

const uploadResponseDefaultValue = {
  _id: '',
  oldName: '',
  orignalName: '',
  newNameWithPath: '',
  showPath: '',
  type: '',
  uid: '',
  compressImagePath: '',
  createAt: dayjs().unix(),
  png: [],
};

const PublishAnnouncement = ({
  disabled,
  propsForAnnouncement,
}: PublishAnnouncementProps) => {
  const [form] = Form.useForm();

  const uploadsService = client.service('uploads');

  const [isOpenPublishAnnouncementModal, setIsOpenPublishAnnouncementModal] =
    useState(false);
  const [isOpenPreviewAnnouncementModal, setIsOpenPreviewAnnouncementModal] =
    useState(false);
  const [uploadedFileInfo, setUploadedFileInfo] = useState<UploadedFileInfo>({
    file: { uid: '', name: '' },
    fileResponse: uploadResponseDefaultValue,
  });

  const closePublishAnnouncementModal = async () => {
    form.resetFields();
    if (uploadedFileInfo.fileResponse._id !== '') {
      await uploadsService.remove(uploadedFileInfo.fileResponse._id);
    }
    setUploadedFileInfo({
      file: { uid: '', name: '' },
      fileResponse: uploadResponseDefaultValue,
    });
    setIsOpenPublishAnnouncementModal(false);
  };

  const closePreviewAnnouncementModal = () => {
    setIsOpenPreviewAnnouncementModal(false);
  };

  const closeAllModal = async () => {
    setIsOpenPreviewAnnouncementModal(false);
    closePublishAnnouncementModal();
  };

  const updateUploadFileInfo = (fileInfo: UploadedFileInfo) => {
    setUploadedFileInfo(fileInfo);
  };

  return (
    <>
      <Modal
        open={isOpenPublishAnnouncementModal}
        onCancel={closePublishAnnouncementModal}
        onOk={() => setIsOpenPreviewAnnouncementModal(true)}
        title="發佈公告"
        footer={null}
      >
        <Form
          form={form}
          onFinish={() => setIsOpenPreviewAnnouncementModal(true)}
        >
          <Form.Item
            label="發佈時間"
            name="announcementTime"
            rules={[{ required: true, message: '請選擇發佈時間' }]}
            initialValue={dayjs()}
          >
            <DatePicker
              inputReadOnly
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
            />
          </Form.Item>
          <Form.Item
            label="標題"
            name="title"
            rules={[{ required: true, message: '請輸入標題' }]}
            initialValue="更新團購訂單管理辦法"
          >
            <Input placeholder="請輸入標題" />
          </Form.Item>
          <Form.Item
            label="內容"
            name="content"
            initialValue={`1.住戶最晚可於團購結單時間前${propsForAnnouncement.closingOrderNumber}${propsForAnnouncement.closingOrderUnit}取消預約，超過時間則不可取消預約。(含住戶推播通知)`}
          >
            <TextArea
              rows={4}
              maxLength={100}
              showCount
              placeholder="請輸入內容"
            />
          </Form.Item>
          <Form.Item
            label="檔案上傳"
            name="uploadFile"
            valuePropName="fileList"
            initialValue={[]}
          >
            <UploadFileForAnnouncement
              updateUploadFileInfo={updateUploadFileInfo}
            />
          </Form.Item>
          <Form.Item>
            <Space className={styles.footerButtonsContainer}>
              <Button type="primary" onClick={closePublishAnnouncementModal}>
                取消
              </Button>
              <Button htmlType="submit">預覽</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
      <Button
        type="primary"
        disabled={disabled}
        onClick={() => setIsOpenPublishAnnouncementModal(true)}
      >
        發佈公告
      </Button>
      <PreviewAnnouncement
        open={isOpenPreviewAnnouncementModal}
        announcementValues={form.getFieldsValue()}
        uploadedFileInfo={uploadedFileInfo}
        closePreviewAnnouncementModal={closePreviewAnnouncementModal}
        closeAllModal={closeAllModal}
      />
    </>
  );
};

export default PublishAnnouncement;
